// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import issEntity from './entities/iss.json';
import issMenu from '../pages/iss/menu.json';
import issFullForm from '../pages/iss/forms/full.json';
import issContextForm from '../pages/iss/forms/context.json';
import issMiniForm from '../pages/iss/forms/mini.json';
import issLookupForm from '../pages/iss/forms/lookup.json';
import issTableView from '../pages/iss/views/table.json';
import issStagesView from '../pages/iss/views/stages.json';
import issCardsView from '../pages/iss/views/cards.json';
import issInlineView from '../pages/iss/views/inline.json';
import issBacklogView from '../pages/iss/views/backlog.json';
import issSplitView from '../pages/iss/views/split.json';
import issCalendarView from '../pages/iss/views/calendar.json';
import issDashboardView from '../pages/iss/views/dashboard.json';

/** Тип запису «Проблема» зі сторінками пакета: меню, форми та подання з pages/iss/. */
export const issDefinition: IRecordTypeDefinition = {
  ...issEntity,
  views: assembleViewSet({
      table: issTableView,
      stages: issStagesView,
      cards: issCardsView,
      inline: issInlineView,
      backlog: issBacklogView,
      split: issSplitView,
      calendar: issCalendarView,
      dashboard: issDashboardView,
  }),
  form: issFullForm,
  forms: { full: issFullForm, context: issContextForm, mini: issMiniForm, lookup: issLookupForm },
  menu: issMenu,
} as IRecordTypeDefinition;
